import { parse } from 'hub-http/helpers/params';
import PortalIdParser from 'PortalIdParser';
const ESCHREF_KEY = 'crm-links::cached-eschref';
const getPortalId = pathname => PortalIdParser.parsePortalIdFromString(pathname, PortalIdParser.pathRegex);
const isDefined = e => typeof e === 'string';
export const isValidEschref = (eschref, pathname, portalId) => {
  return isDefined(eschref) && eschref.indexOf('/') === 0 && eschref.indexOf('//') !== 0 && getPortalId(pathname) === portalId;
};
export const extractEschrefFromLocation = () => {
  const portalId = PortalIdParser.get();
  const {
    search,
    pathname
  } = window.location;
  const {
    eschref
  } = parse(String(search).substring(1));
  return !Array.isArray(eschref) && isValidEschref(eschref, pathname, portalId) ? eschref : null;
};
const interactWithSessionStorage = action => {
  try {
    switch (action) {
      case 'getItem':
        return window.sessionStorage.getItem(ESCHREF_KEY);
      case 'removeItem':
        window.sessionStorage.removeItem(ESCHREF_KEY);
        break;
      case 'setItem':
        window.sessionStorage.setItem(ESCHREF_KEY, String(extractEschrefFromLocation()));
        break;
      default:
        return null;
    }
  } catch (e) {
    // We can't guarantee sessionsStorage and it isn't required
  }
  return null;
};
const PageReturnLinkHelper = {
  addToSessionStorage() {
    const eschref = extractEschrefFromLocation();
    if (eschref) {
      interactWithSessionStorage('setItem');
    }
  },
  get() {
    const eschref = extractEschrefFromLocation();
    const cachedEschref = interactWithSessionStorage('getItem');
    if (eschref) {
      return eschref;
    } else if (cachedEschref) {
      return cachedEschref;
    }
    return null;
  },
  clear() {
    interactWithSessionStorage('removeItem');
  }
};
export default PageReturnLinkHelper;